export default function isNotFalsy<T>(value: T): value is Exclude<T, null | undefined | false | '' | 0> {
    return !!value;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it, expect } = import.meta.vitest;
    describe('isNotFalsy', () => {
        it('returns false for values that resolves to False', () => {
            expect(isNotFalsy(false)).toBe(false);
            expect(isNotFalsy(0)).toBe(false);
            expect(isNotFalsy('')).toBe(false);
            expect(isNotFalsy(undefined)).toBe(false);
            expect(isNotFalsy(null)).toBe(false);
        });

        it('returns true for values that resolves to True', () => {
            expect(isNotFalsy(true)).toBe(true);
            expect(isNotFalsy(1)).toBe(true);
            expect(isNotFalsy(0.1)).toBe(true);
            expect(isNotFalsy(-1)).toBe(true);
            expect(isNotFalsy('a')).toBe(true);
            expect(isNotFalsy('0')).toBe(true);
            expect(isNotFalsy(' ')).toBe(true);
            expect(isNotFalsy({})).toBe(true);
            expect(isNotFalsy([])).toBe(true);
            expect(isNotFalsy(() => {})).toBe(true);
        });
    });
}

// #endregion
